import { render, staticRenderFns } from "./store-position-tab.vue?vue&type=template&id=a5f886c6"
import script from "./store-position-tab.vue?vue&type=script&lang=js"
export * from "./store-position-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports